import React, { Component} from 'react';
import { inject, observer } from 'mobx-react';
import text from '../../texts/translations';

@inject('languageStore')
@observer
export default class Translation extends Component {
  render() {
    let lang = this.props.languageStore.language;
    let translation = text[this.props.children];

    if (!translation) {
      return this.props.children;
    } else if (typeof translation === 'string') {
      return translation;
    } else {
      return translation[lang] || translation[process.env.REACT_APP_DEFAULT_LANGUAGE];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Translation/Translation.jsx